<template>
  <div class="ew-empty" :class="{ 'ew-empty--compact': compact, 'ew-empty--error': error }" role="status">
    <div class="ew-empty-icon"><i :class="icon"></i></div>
    <p class="ew-empty-title">{{ title }}</p>
    <p v-if="text" class="ew-empty-text">{{ text }}</p>
    <div v-if="$slots.default" class="ew-empty-action">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    title: { type: String, required: true },
    text: { type: String, default: '' },
    icon: { type: String, default: 'bi bi-inbox' },
    compact: { type: Boolean, default: false },
    error: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.ew-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  text-align: center;
}

.ew-empty--compact {
  padding: 20px 12px;
}

.ew-empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-bottom: 12px;
  border-radius: 12px;
  background: #f1f3fa;
  color: #031d7d;
  font-size: 1.4rem;
}

.ew-empty--compact .ew-empty-icon {
  width: 36px;
  height: 36px;
  margin-bottom: 8px;
  font-size: 1.05rem;
}

.ew-empty--error .ew-empty-icon {
  background: #fdecea;
  color: #d92d20;
}

.ew-empty-title {
  margin: 0;
  color: #1c2030;
  font-size: 0.95rem;
  font-weight: 600;
}

.ew-empty-text {
  max-width: 360px;
  margin: 4px 0 0;
  color: #6b7185;
  font-size: 0.85rem;
}

.ew-empty-action {
  margin-top: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/EmptyState.vue